(function (factory) {
    typeof define === 'function' && define.amd ? define(['kendo.core'], factory) :
    factory();
})((function () {
    (function( window, undefined$1 ) {
        kendo.cultures["ne-IN"] = {
            name: "ne-IN",
            numberFormat: {
                pattern: ["-n"],
                decimals: 2,
                ",": ",",
                ".": ".",
                groupSize: [3],
                percent: {
                    pattern: ["-n%","n%"],
                    decimals: 2,
                    ",": ",",
                    ".": ".",
                    groupSize: [3],
                    symbol: "%"
                },
                currency: {
                    name: "Indian Rupee",
                    abbr: "INR",
                    pattern: ["-$ n","$ n"],
                    decimals: 2,
                    ",": ",",
                    ".": ".",
                    groupSize: [3],
                    symbol: "₹"
                }
            },
            calendars: {
                standard: {
                    days: {
                        names: ["आइतबार","सोमबार","मङ्गलबार","बुधबार","बिहिबार","शुक्रबार","शनिबार"],
                        namesAbbr: ["आइत","सोम","मङ्गल","बुध","बिहि","शुक्र","शनि"],
                        namesShort: ["आइत","सोम","मङ्गल","बुध","बिहि","शुक्र","शनि"]
                    },
                    months: {
                        names: ["जनवरी","फेब्रुअरी","मार्च","अप्रिल","मे","जुन","जुलाई","अगस्ट","सेप्टेम्बर","अक्टोबर","नोभेम्बर","डिसेम्बर"],
                        namesAbbr: ["जनवरी","फेब्रुअरी","मार्च","अप्रिल","मे","जुन","जुलाई","अगस्ट","सेप्टेम्बर","अक्टोबर","नोभेम्बर","डिसेम्बर"]
                    },
                    AM: ["पूर्वाह्न","पूर्वाह्न","पूर्वाह्न"],
                    PM: ["अपराह्न","अपराह्न","अपराह्न"],
                    patterns: {
                        d: "yyyy/M/d",
                        D: "yyyy MMMM d, dddd",
                        F: "yyyy MMMM d, dddd h:mm:ss tt",
                        g: "yyyy/M/d h:mm tt",
                        G: "yyyy/M/d h:mm:ss tt",
                        m: "MMMM d",
                        M: "MMMM d",
                        s: "yyyy'-'MM'-'dd'T'HH':'mm':'ss",
                        t: "h:mm tt",
                        T: "h:mm:ss tt",
                        u: "yyyy'-'MM'-'dd HH':'mm':'ss'Z'",
                        y: "yyyy MMMM",
                        Y: "yyyy MMMM"
                    },
                    "/": "/",
                    ":": ":",
                    firstDay: 0
                }
            }
        };
    })();

}));
